<template>
  <div>
    <div class="warning-message-class">
      <translate>You will be able to use your premium features, multiple companies and extra users until your current subscription
      runs out. If you change your mind you can always upgrade back to premium.</translate>
    </div>

    <label for="input-live">
      <translate>Please choose the default company profile you want to keep using</translate>
      *
    </label>
    <b-form-select v-model="selected" :options="options"/>

    <DowngradeReasonSelector v-model="reason"/>

    <b-row class="float-right">
      <b-col cols="3">
        <GekkoButton
            :to="{name: 'Subscriptions'}"
            :text="$gettext('Back')"
        />
      </b-col>
      <b-col cols="9">
        <GekkoButton
            @click="downgradeUrl(reason)"
            :text="$gettext('Cancel subscription')"
            :disabled="!selected || !reason"
            class="text-danger"
            variant="link"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import settingsPageSetup from "@/mixins/settingsPageSetup";
import GekkoButton from "@/components/GekkoButton";
import CompanyService from "@/store/services/company.service.js";
import BillingSettingService from "@/store/services/billingsetting.service";
import DowngradeReasonSelector from "@/components/list_filters/DowngradeReasonSelector.vue";

export default {
  name: "DowngradeSubscription",
  components: {DowngradeReasonSelector, GekkoButton},
  mixins: [settingsPageSetup],
  created() {
    CompanyService.companyPickerOptions().then((response) => {
      response.data.profile_companies.forEach(company => {
        this.options.push({
          value: company[0].id,
          text: company[0].name
        });
      });
      this.selected = this.options[0].value; // first option selected by default
    });
  },
  data() {
    return {
      pageSettings: {
        title: "Cancel your subscription",
        showCompanyPicker: false
      },
      options: [],
      selected: null,
      reason: null,
    }
  },
  methods: {
    downgradeUrl() {
      BillingSettingService.cancelPremium(this.reason).then((response) => {
            this.$router.push({name: 'Subscriptions'}).then(() => {
              this.$store.commit('setAlert', {
                title: this.$gettext('Subscription cancelled'),
                text: this.$gettext('Your account will be downgraded on') + ' ' + response.data.get_end_date,
                duration: 4
              })
            })
          }
      )
    }
  }
}
</script>

<style lang="scss">
.warning-message-class {
  background-color: #ffc9c5;
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
  border: 1px solid #919191;
  border-radius: $radiusSm;
  margin: 0 0 20px;
}

.help-text {
  color: #888;
  font-size: 14px;
  margin-top: 5px;
}
</style>
